import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { cartService, AddToCartRequest, BasketSummaryResponse } from '../services/cartService';

// Query keys
export const cartQueryKeys = {
  summary: ['cart', 'summary'] as const,
};

// Hook for fetching basket summary
export const useBasketSummary = (enabled: boolean = true) => {
  return useQuery({
    queryKey: cartQueryKeys.summary,
    queryFn: async (): Promise<BasketSummaryResponse> => {
      return cartService.getBasketSummary();
    },
    enabled,
    staleTime: 30 * 1000, // 30 seconds - data becomes stale quickly
    gcTime: 5 * 60 * 1000, // 5 minutes
    refetchOnMount: true, // Refetch on mount if data is stale
    refetchOnWindowFocus: true, // Refetch when user returns to tab
  });
};

// Hook for adding to cart
export const useAddToCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: AddToCartRequest) => {
      return cartService.addToCart(request);
    },
    onSuccess: () => {
      // Invalidate basket summary to refetch
      queryClient.invalidateQueries({ queryKey: cartQueryKeys.summary });
    },
  });
};
